
<div class="container">

    <div class="row">
        <div class="col-md-12">
            
              
               

                    <!-- <form method="get" action="../../../assets/Ankit_Resume_Academic.pdf" target="_black">
                        <button type="submit" class="btn btn-success">
                            <i class="fas fa-file-download"></i> Download CV Here
                        </button>
                     </form> -->

                   
             
            
           
            
        </div>
        
    </div>



    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Education</h6>
                    <div id="content">
                        <ul class="timeline">
                            <li class="event" data-date="2018 - Present">
                                <h3> <a href="https://www.nd.edu/">University of Notre Dame, Indiana, USA</a></h3>
                                <h3>Ph.D. in Computer Science</h3>
                                <p> <span style="font-weight: bold;">Specialization</span> : Human Computer Interaction</p>
                                <p><span style="font-weight: bold;">Research Advisor</span> : Dr. Jane Cleland-Huang</p>
                            </li>
                            <li class="event" data-date="2013-2015">
                                <h3> <a href="https://www.nitrkl.ac.in">National Institute of Technology, Rourkela, India </a></h3>
                               <h3> Masters' in Software Engineering</h3>
                               <p><span style="font-weight: bold;">Research Advisor</span> : Dr. S.K. Rath</p>
                            </li>
                            <li class="event" data-date="2009-2013">
                                <h3> <a href="http://www.ipu.ac.in/">Indraprastha University, New Delhi, India</a></h3>
                               <h3> B.S. in Computer Science</h3>
                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Invited Talks</h6>
                    <div id="content">
                        
                        <ul class="timeline">                            
                            <li class="event" data-date="2020">
                                <h3>STEM Outreach Seminar</h3> 
                                University of Notre Dame
                                
                            </li>
                            <li class="event" data-date="2019">
                                <h3>Poster Presentation</h3>
                                Northrop Grumman 2019 Tech Fest
                            </li>
                            <li class="event" data-date="2019">
                               <h3>Showcased DroneResponse Project</h3>
                               University of Gothenburg, Sweden 
                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Academic Services</h6>
                    <div id="content">
                        
                        <ul class="timeline">                            
                            <li class="event" data-date="2021">
                                <h3>Student Volunteer Co-Chair</h3>
                                Requirements Engineering 2021
                            </li>
                            <li class="event" data-date="2020">
                                <h3>Reviewer</h3>                                
                                CHI-2021
                            </li>
                            <li class="event" data-date="2019">
                                <h3> Student Volunteer</h3>
                                International Conference of Software Engineering (ICSE-2019)
                            </li>
                            
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Awards</h6>
                    <div id="content">
                        
                        <ul class="timeline">                            
                            <li class="event" data-date="2020">
                                <h3>Best Paper Award</h3>
                                Software Product Line Conference - SPLC 2020 <hr>

                                <h3>Best Paper Honoroble Mention</h3>
                                CHI-2020
                            </li>
                            <li class="event" data-date="2013-2015">
                                <h3>Graduate Teaching Assistant Fellowship</h3>
                                National  Institute  of  Technology,Rourkela
                            </li>
                            
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Skills</h6>
                    <div id="content">
                        
                        <ul class="timeline">                            
                            <li class="event" data-date="Development">
                                <h3>Front End</h3>
                                TypeScript, Angular2+, JavaScript, WebPack, HTML, LESS <hr>

                                <h3>Back End</h3>
                                Node, Java, Python, C#, C++, C
                            </li>
                             
                            <li class="event" data-date="UX Methods">
                                A/B testing, Surveying, Usability Test, Interview, Experiment Design
                            </li>
                            
                            <li class="event" data-date="Tools">
                                Git, Adobe xD, MTurk, LATEX
                            </li>

                            <li class="event" data-date="Management">
                                Agile, Certified Scrum Master
                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Academic Experience</h6>
                    <div id="content">
                        
                        <ul class="timeline">                            
                            <li class="event" data-date="2020">
                                <h3>Team Leader - NSF-REU Program</h3>
                                University of Notre Dame<hr>
                                <h3>Guest Lecture</h3>
                                Introduction to Web Development, University of Notre Dame
                            </li>
                                
                            <li class="event" data-date="2019">
                                <h3>Team Leader - NSF-REU Program</h3>
                                University of Notre Dame                                
                                <hr>
                                <h3>Teaching Assistant, University of Notre Dame</h3>
                                CSE 40773 - Software Development for UAS
                            </li>
                            <li class="event" data-date="2018">
                                <h3> Teaching Assistant, University of Notre Dame</h3>
                                CSE 40793 - Software Design Practices
                            </li>

                            <li class="event" data-date="2015">
                                <h3> Teaching Assistant, National Institute of Technology, Rourkela</h3>
                                CS 621 - Cryptographic Foundations <br>
                                CS 666 - Software Design Practices
                                
                            </li>
                            <li class="event" data-date="2014">
                                <h3> Teaching Assistant, National Institute of Technology, Rourkela</h3>
                                CS 690 - Requirements Engineering Laboratory 
                                
                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h6 class="card-title">Industrial Experience</h6>
                    <div id="content">
                        
                        <ul class="timeline">                            
                            <li class="event" data-date="2015-2018">
                                <h3>FIS Global, India</h3>
                                Full Stack Software Engineer
                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
